<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import AdminLayout from '@/Shared/AdminLayout'

export default {
  components: {
    Head,
  },
  layout: AdminLayout,
}
</script>
